// 顶级域名
export const topDomain = window.location.host ? window.location.host.replace(/(.)+\.(\w+)$/g, '$2') : 'org'

export default {
  defaultAvatar: require('../assets/img/defaultAvatar.jpg'),
  timeHost: 'https://time.geekbang.org',
  infoQHost: 'https://www.infoq.cn',
  ENV: 'prod',
  baseHost: `https://www.geekbang.${topDomain}`,
  accountServer: `https://account.geekbang.${topDomain}`,
  bServer: `https://b.geekbang.${topDomain}`,
  cashierServer: `https://cashier.geekbang.${topDomain}`,
  geekbangServer: `https://www.geekbang.${topDomain}`,
  hordeServer: `https://horde.geekbang.${topDomain}`,
  liveServer: `https://live.geekbang.${topDomain}`,
  miscServer: `https://misc.geekbang.${topDomain}`,
  promoServer: `https://promotion.geekbang.${topDomain}`,
  timeServer: `https://time.geekbang.${topDomain}`,
  tipsServer: `https://tips.geekbang.${topDomain}`,
  universityServer: `//u.geekbang.${topDomain}`,
  infoq: 'https://www.infoq.cn',
  infoqMeeting: 'https://www.infoq.cn/archives', // infoq 技术大会
  tgo: 'https://tgo.infoq.cn'
}
